import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, MessageCircle, Menu, X } from 'lucide-react';
import { companyInfo } from '../mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // 🔹 Header background scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🔹 Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/91${companyInfo.whatsapp}?text=Hi, I'm interested in your properties`,
      '_blank'
    );
  };

  const handleCall = () => {
    window.location.href = `tel:+91${companyInfo.phones[0]}`;
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/properties', label: 'Properties' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header
      className={`header fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'header-scrolled' : ''
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <Link to="/" className="logo-wrapper group flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_2a73fc45-adbf-44a6-8139-8de8d79a04e7/artifacts/09g17uyg_ChatGPT%20Image%20Jan%202%2C%202026%2C%2005_19_57%20PM.png"
              alt="UNITYPRO HOMES Logo"
              className="h-14 md:h-16 lg:h-20 w-auto object-contain"
            />
            <div className="hidden sm:block">
              <h1 className="text-lg md:text-xl font-bold gradient-text">
                {companyInfo.name}
              </h1>
              <p className="text-xs text-orange-400 font-semibold">
                {companyInfo.slogan}
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${
                  location.pathname === link.path ? 'nav-link-active' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Action Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <Button size="sm" variant="outline" className="header-button" onClick={handleCall}>
              <Phone className="w-4 h-4 mr-2" />
              Call
            </Button>
            <Button size="sm" className="header-button-primary" onClick={handleWhatsApp}>
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu lg:hidden">
          <div className="container mx-auto px-4 py-6">
            <nav className="flex flex-col space-y-4 mb-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`mobile-nav-link ${
                    location.pathname === link.path
                      ? 'mobile-nav-link-active'
                      : ''
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <div className="flex flex-col space-y-3">
              <Button className="w-full header-button-primary" onClick={handleWhatsApp}>
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp Us
              </Button>
              <Button variant="outline" className="w-full header-button" onClick={handleCall}>
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
